import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Profile } from '../../types/Profile';
import { RootState } from '../../app/store';

const initialProfileState: Profile = {
    id: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    country: '',
    mfa: false,
    orgAdmin: false,
    roles: [],
    email: '',
    areaCode: '',
    image: '',
};

const profileSlice = createSlice({
    name: 'profile',
    initialState: {
        profile: initialProfileState,
        globalPermissions: undefined,
        permissions: undefined,
        preferredLanguage: [],
        routePermissions: undefined,
        routePermissionScopeKey: undefined,
        currentRoleId: '',
    } as any,
    reducers: {
        setProfile: (state, action: PayloadAction<Profile>) => {
            const profile: Profile = action.payload;
            state.profile = profile;
        },
        setResetPermissions: (state) => {
            if (state.permissions?.length && state.globalPermissions?.length) {
                state.permissions = state.globalPermissions;
                state.globalPermissions = [];
                state.routePermissionScopeKey = undefined;
                return;
            }
        },

        setNewGlobalPermission: (state) => {
            if (state.globalPermissions?.length && state.permissions?.length) {
                state.globalPermissions = state.permissions;
            }
        },

        setPermissions: (state, action: PayloadAction<any>) => {
            if (state.permissions?.length && !state.globalPermissions?.length) {
                state.globalPermissions = state.permissions;
            }
            const permissions: any = action.payload.permissions;
            state.permissions = permissions;
            state.routePermissionScopeKey = action.payload.scopeKey;
            if (action.payload.isRoute) {
                state.routePermissions = permissions;
            }
        },
        setPreferredLanguage: (state, action: PayloadAction<any>) => {
            const preferredLanguage: any = action.payload;
            state.preferredLanguage = preferredLanguage;
        },
    },
});

export const { setProfile, setPermissions, setResetPermissions, setNewGlobalPermission, setPreferredLanguage } =
    profileSlice.actions;
export default profileSlice;

export const selectCurrentProfile = (state: RootState): Profile => state.profile.profile;
export const selectCurrentPermission = (state: RootState): any => state.profile.permissions;
export const selectGlobalPermissions = (state: RootState): any => state.profile.globalPermissions;
export const selectRoutePermissionScopeKey = (state: RootState): any => state.profile.routePermissionScopeKey;
export const selectCurrentPreferredLanguage = (state: RootState): any => state.profile.preferredLanguage;
